import React from "react";
import { Link } from "react-router-dom";

export function LevelBadge({ level, xp, progress, showBar = true, className = "" }) {
  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-[#E50914]/15 border border-[#E50914]/40 text-[#E50914] text-[10px] font-black uppercase tracking-[0.2em]">
        Lv {level}
      </span>
      {showBar && progress != null && (
        <div className="flex items-center gap-1.5">
          <div className="w-20 h-1.5 bg-white/5 rounded-full overflow-hidden">
            <div className="h-full bg-gradient-to-r from-[#E50914] to-[#FF9F0A]" style={{ width: `${progress.progress_pct || 0}%` }} />
          </div>
          <span className="text-[10px] font-bold text-zinc-400">{progress.xp_into_level || 0}/{progress.xp_next_level || 0}</span>
        </div>
      )}
    </div>
  );
}

export function PatreonBadge({ tier, className = "" }) {
  if (!tier) return null;
  const isCreator = tier === "Creator";
  const isSuper = tier === "Super Savager";
  const style = isCreator
    ? "bg-gradient-to-r from-[#FFD700]/25 to-[#FF9F0A]/20 border-[#FFD700]/60 text-[#FFD700] shadow-[0_0_12px_rgba(255,215,0,0.25)]"
    : isSuper
      ? "bg-[#FF9F0A]/15 border-[#FF9F0A]/50 text-[#FF9F0A]"
      : "bg-[#E50914]/15 border-[#E50914]/50 text-[#E50914]";
  const testid = isCreator ? "creator" : isSuper ? "super" : "savager";
  return (
    <span
      data-testid={`patreon-badge-${testid}`}
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-black uppercase tracking-[0.18em] border ${style} ${className}`}
    >
      {tier}
    </span>
  );
}

export function UserBadge({ user, size = "sm" }) {
  if (!user) return null;
  const s = size === "lg" ? "w-10 h-10 text-base" : "w-8 h-8 text-xs";
  return (
    <Link to={`/users/${user.id}`} data-testid={`user-link-${user.id}`} className="inline-flex items-center gap-2 group">
      <span className={`rounded-full bg-gradient-to-br from-[#E50914] to-[#7a0309] flex items-center justify-center font-black uppercase overflow-hidden ${s}`}>
        {user.avatar ? <img src={user.avatar} alt="" className="w-full h-full object-cover" /> : (user.name || "?")[0]}
      </span>
      <span className="text-sm font-bold text-zinc-200 group-hover:text-[#E50914]">{user.name}</span>
      {user.level && <span className="text-[10px] font-black text-[#E50914]">Lv{user.level}</span>}
      {user.patreon_tier && <PatreonBadge tier={user.patreon_tier} />}
    </Link>
  );
}
